import { Row, Col } from "react-bootstrap";
import React, { useEffect, useState } from "react";

import SelectDropDown from "../selectDropdown/SelectDropdown";
import {
  PRODUCT_TYPES_ENUMS,
  SET_BY_MARGIN_ENUMS,
} from "../../../system/globalEnums";
import {
  getCustomCategoriesOptionList,
  getCustomSubCategoriesOptionList,
  getCustomTypesOptionList,
  getDefaultFilterType,
} from "../../utility";

import { multiSelectStyles } from "../../../assets/scss/style";

const TradeFilters = ({
  setBy,
  customTypes,
  customCategories,
  customSubCategories,
  setFilterProductType,
  setFilterProductCategory,
  fromDiscount = false,
}) => {
  const defaultAllTypeOptions = getDefaultFilterType(
    customTypes,
    PRODUCT_TYPES_ENUMS.ALL
  );
  const defaultVideogameTypeOptions = getDefaultFilterType(
    customTypes,
    PRODUCT_TYPES_ENUMS.VIDEO_GAME
  );

  const [productCategory, setProductCategory] = useState();
  const [productSubCategory, setProductSubCategory] = useState();
  const [productType, setProductType] = useState(defaultAllTypeOptions);

  const [categoryOptions, setCategoryOptions] = useState(
    getCustomCategoriesOptionList(
      customTypes,
      productType?.value,
      productType.label
    )
  );

  useEffect(() => {
    //we need to show "All" option for every product Types
    setCategoryOptions(
      setBy !== SET_BY_MARGIN_ENUMS.PRODUCT.value
        ? [
            {
              value: PRODUCT_TYPES_ENUMS.ALL,
              label: PRODUCT_TYPES_ENUMS.ALL,
            },
            ...getCustomCategoriesOptionList(
              customCategories,
              productType?.value,
              productType?.label
            ),
          ]
        : getCustomCategoriesOptionList(
            customCategories,
            productType?.value,
            productType?.label
          )
    );

    //setting the default selected category
    const defaultproductCategory = {
      value: PRODUCT_TYPES_ENUMS.ALL,
      label: PRODUCT_TYPES_ENUMS.ALL,
    };
    setProductCategory(defaultproductCategory);
    setFilterProductCategory(defaultproductCategory);
  }, [productType, customCategories]);

  useEffect(() => {
    if (setBy === SET_BY_MARGIN_ENUMS.PRODUCT.value || fromDiscount) {
      setProductType(defaultVideogameTypeOptions);
      setFilterProductType(defaultVideogameTypeOptions);
    } else {
      setProductType(defaultAllTypeOptions);
      setFilterProductType(defaultAllTypeOptions);
    }
  }, [customTypes, setBy]);

  return (
    <Row className="m-0 px-0">
      {setBy === SET_BY_MARGIN_ENUMS.TYPE.value ? (
        ""
      ) : setBy === SET_BY_MARGIN_ENUMS.CATEGORY.value ? (
        <Col md={12} className="px-md-0 mb-3">
          <label>Select Type</label>
          <SelectDropDown
            menuPortalTarget={""}
            menuPlacement={"bottom"}
            placeHolder="Select Type..."
            options={getCustomTypesOptionList(customTypes)}
            defaultPageSize={getCustomTypesOptionList(customTypes)[0]}
            value={productType}
            handleChange={(e) => {
              setProductType(e);
              setFilterProductType(e);
            }}
          />
        </Col>
      ) : setBy === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value ? (
        <>
          <Col md={6} className="ps-md-0 mb-3">
            <label>Select Type</label>
            <SelectDropDown
              menuPortalTarget={""}
              menuPlacement={"bottom"}
              placeHolder="Select Type..."
              options={getCustomTypesOptionList(customTypes)}
              defaultPageSize={getCustomTypesOptionList(customTypes)[0]}
              value={productType}
              handleChange={(e) => {
                setProductType(e);
                setFilterProductType(e);
              }}
            />
          </Col>
          <Col md={6} className="pe-md-0 mb-3">
            <label>Select Category</label>
            {fromDiscount ? ( //if from discount we want to have multiselect dropdown for categories
              <SelectDropDown
                menuPortalTarget={""}
                menuPlacement={"bottom"}
                placeHolder="Select Category..."
                options={categoryOptions}
                defaultPageSize={categoryOptions[0]}
                value={productCategory}
                handleChange={(selectedOptions) => {
                  if (!selectedOptions) {
                    setProductCategory([]);
                    setFilterProductCategory([]);
                    return;
                  }

                  const currentSelection = Array.isArray(productCategory)
                    ? productCategory
                    : [productCategory] || [];
                  const isAllPreviouslySelected = currentSelection.some(
                    (opt) => opt.value === PRODUCT_TYPES_ENUMS.ALL
                  );
                  // Check if "All" is selected
                  const allOption = categoryOptions.find(
                    (opt) => opt.value === PRODUCT_TYPES_ENUMS.ALL
                  );
                  const allSelected = selectedOptions.some(
                    (opt) => opt.value === PRODUCT_TYPES_ENUMS.ALL
                  );

                  let newSelection;

                  if (allSelected) {
                    if (isAllPreviouslySelected) {
                      // if all was selected and something else selected remove all
                      newSelection = selectedOptions.filter(
                        (opt) => opt.value !== PRODUCT_TYPES_ENUMS.ALL
                      );
                    } else {
                      // Only keep "All"
                      newSelection = [allOption];
                    }
                  } else {
                    // if other options are selected
                    newSelection = selectedOptions.filter(
                      (opt) => opt.value !== PRODUCT_TYPES_ENUMS.ALL
                    );
                  }

                  setProductCategory(newSelection);
                  setFilterProductCategory(newSelection);
                }}
                isSearchable={true}
                isMulti={true}
                styles={multiSelectStyles}
              />
            ) : (
              <SelectDropDown
                menuPortalTarget={""}
                menuPlacement={"bottom"}
                placeHolder="Select Category..."
                options={categoryOptions}
                defaultPageSize={categoryOptions[0]}
                value={productCategory}
                handleChange={(e) => {
                  setProductCategory(e);
                  setFilterProductCategory(e);
                }}
                isSearchable={true}
              />
            )}
          </Col>
        </>
      ) : (
        ""
      )}
    </Row>
  );
};

export default TradeFilters;
